import { useEffect } from 'react';
import { Link } from 'react-router-dom';

import { Seo } from '../components/Seo';
import { track } from '../lib/analytics';
import { formatPostDate, getAllPosts } from '../lib/blog';

const TITLE = 'Blog · Prepzio';
const DESCRIPTION =
  'Practical guides for AI-using junior developers: interview readiness, learning without copy-paste, and building real skills.';

const BlogIndex = () => {
  const posts = getAllPosts();

  useEffect(() => {
    track('blog_index_view', { post_count: posts.length });
  }, [posts.length]);

  return (
    <>
      <Seo title={TITLE} description={DESCRIPTION} path="/blog" />
      <section className="section blog-index">
        <div className="container">
          <p className="eyebrow">Blog</p>
          <h1 className="h-section h-section--wide">
            Practical guides for AI-using junior developers
          </h1>
          <p className="lede">
            How to explain your code in interviews, stop copying AI answers, and build skills that
            actually stick, without another LeetCode grind.
          </p>

          <ul className="blog-index__list">
            {posts.map((post) => (
              <li key={post.slug}>
                <article className="blog-card">
                  <div className="blog-card__meta">
                    <time dateTime={post.publishedAt}>{formatPostDate(post.publishedAt)}</time>
                    <span aria-hidden="true">·</span>
                    <span>{post.readingTimeMinutes} min read</span>
                  </div>
                  <h2 className="blog-card__title">
                    <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                  </h2>
                  <p className="blog-card__desc">{post.description}</p>
                  {post.tags.length > 0 && (
                    <ul className="blog-card__tags" aria-label="Tags">
                      {post.tags.map((tag) => (
                        <li key={tag}>{tag}</li>
                      ))}
                    </ul>
                  )}
                  <Link className="blog-card__link" to={`/blog/${post.slug}`}>
                    Read article →
                  </Link>
                </article>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </>
  );
};

export default BlogIndex;
